import { __rest } from "tslib";
import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Label, RadioGroup, RadioGroupItem } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <RadioGroup defaultValue="comfortable">
 *       <div className="flex items-center space-x-2">
 *         <RadioGroupItem value="default" id="r1" />
 *         <Label htmlFor="r1">Default</Label>
 *       </div>
 *       <div className="flex items-center space-x-2">
 *         <RadioGroupItem value="comfortable" id="r2" />
 *         <Label htmlFor="r2">Comfortable</Label>
 *       </div>
 *       <div className="flex items-center space-x-2">
 *         <RadioGroupItem value="compact" id="r3" />
 *         <Label htmlFor="r3">Compact</Label>
 *       </div>
 *     </RadioGroup>
 *   )
 * }
 * ```
 */
const RadioGroup = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(RadioGroupPrimitive.Root, Object.assign({ className: cn("grid gap-2", className) }, props, { ref: ref })));
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(RadioGroupPrimitive.Item, Object.assign({ ref: ref, className: cn("aspect-square h-4 w-4 rounded-full border border-skvegreen-400 text-skvegreen-400 ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className) }, props),
        React.createElement(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center" },
            React.createElement(Circle, { className: "h-2.5 w-2.5 fill-current text-current" }))));
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
export { RadioGroup, RadioGroupItem };
//# sourceMappingURL=radio-group.js.map